module.exports = __webpack_public_path__ + "img/spark.a021b020.png";